import { walkingSurface } from './walkingSurface';
import { medias } from './../Global/medias.js';

class WalkingSurfaceAssessorSlides {
  constructor(app, report, evaluation, group, user) {
    this.app = app;
    this.report = report;
    this.evaluation = evaluation;
    this.group = group;
    this.user = user;
  }

  add(tableOfContentsCalculatorPosition) {
    let assessor = this.group.getAssessorByType('18');

    if (assessor === false || assessor.assessor.data === undefined) {
      throw (
        this.group.getName() +
        this.app.$t(' - ') +
        this.app.$t('Walking Surface') +
        this.app.$t(' assessor is not ready.')
      );
    }

    this.report.tableOfContentsHelper(
      'Walking Surface',
      tableOfContentsCalculatorPosition,
      this.group,
    );

    walkingSurface(this.app, this.report, this.evaluation, this.group, assessor);
    medias(this.app, this.report, this.group, '18', this.user);
  }
}

export default WalkingSurfaceAssessorSlides;
